import React from 'react';
import PropTypes from 'prop-types';
import { AddressValidation, AddressValidationProvider } from '@homeexchange/home';

import { getDynamicUrl } from '../../middleware/lokaliseUrlMiddleware';

const HomeAddressCollection = (props) => {
    const { addressFlow, config, countryOptions, onConfirm } = props;
    const bffUrl = getDynamicUrl(process.env.URL_BFF);

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm();
    };

    return (
        <form id="form-step-3" onSubmit={handleSubmit}>
            <AddressValidationProvider locale={config.locale} bffUrl={bffUrl}>
                <AddressValidation
                    value={addressFlow.value}
                    onChange={addressFlow.onChange}
                    config={config}
                    countryOptions={countryOptions}
                    step={addressFlow.step}
                    errors={addressFlow.errors}
                    isPinTooFar={addressFlow.isPinTooFar}
                    onAddressNotListed={addressFlow.goToManualEntry}
                    onManualLocationCommitted={addressFlow.registerUnrecognizedLocation}
                    onSuggestionSelected={onConfirm}
                />
            </AddressValidationProvider>
        </form>
    );
};

HomeAddressCollection.propTypes = {
    addressFlow: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    countryOptions: PropTypes.array,
    onConfirm: PropTypes.func.isRequired
};

export default HomeAddressCollection;
